export default __webpack_public_path__ + "static/media/evoETH.c34a2182.svg";